import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import { Helmet } from "react-helmet-async";

function About() {
  return (
    <>
      <Helmet>
        <title>About Cosmin Pascariu — Front-end & Mobile Developer</title>
        <meta
          name="description"
          content="Short bio, skills and toolset: React, React Native, TypeScript. I care about performance, DX and accessible UIs."
        />
        <link rel="canonical" href="https://cosminpascariu.comabout" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cosmin Pascariu" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="About Cosmin Pascariu" />
        <meta
          property="og:description"
          content="Bio, skills and tech stack: React, React Native, TypeScript."
        />
        <meta property="og:url" content="https://cosminpascariu.comabout" />
        <meta
          property="og:image"
          content="https://cosminpascariu.comog/cosmin-1200x630.jpg"
        />
        <meta
          property="og:image:alt"
          content="Cosmin Pascariu — profile photo"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Cosmin Pascariu" />
        <meta
          name="twitter:description"
          content="Bio, skills and tech stack."
        />
        <meta
          name="twitter:image"
          content="https://cosminpascariu.comog/cosmin-1200x630.jpg"
        />

        <script type="application/ld+json">{`
  {
    "@context": "https://schema.org",
    "@type": ["ProfilePage","WebPage"],
    "@id": "https://cosminpascariu.com#profile",
    "url": "https://cosminpascariu.comabout",
    "name": "About Cosmin Pascariu — Front-end & Mobile Developer",
    "inLanguage": "en-US",
    "mainEntity": { "@id": "https://cosminpascariu.com#me" },
    "about":      { "@id": "https://cosminpascariu.com#me" },
    "isPartOf":   { "@id": "https://cosminpascariu.com#website" }
  }
  `}</script>

        <script type="application/ld+json">{`
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cosminpascariu.com" },
      { "@type": "ListItem", "position": 2, "name": "About", "item": "https://cosminpascariu.comabout" }
    ]
  }
  `}</script>
      </Helmet>
      <Container fluid className="about-section">
        <Particle />
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                Know Who <strong className="purple">I'M</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img src={laptopImg} alt="Cosmin Pascariu workspace" className="img-fluid" />
            </Col>
          </Row>
          <h1 className="project-heading">
            Professional <strong className="purple">Skillset </strong>
          </h1>

          <Techstack />

          <h1 className="project-heading">
            <strong className="purple">Tools</strong> I use
          </h1>
          <Toolstack />

          <Github />
        </Container>
      </Container>
    </>
  );
}

export default About;
